// Que grupos del club se pueden inscribir en un torneo INTERNO, por deporte.
//
// Un torneo de flag ofrecia tambien el grupo de tackle (el dueno lo vio el 2026-09-05).
// El torneo no guarda deporte: lo hereda de su TEMPORADA, que desde el 04 es obligatoria
// en el interno y se define por deporte. Un torneo viejo sin temporada no puede filtrar,
// y no se inventa: ofrece todos y que el club elija.
//
// En la red no aplica: ahi la categoria convocada por la organizadora es la que acota.

const normaliza = (v) => (v === null || v === undefined ? '' : String(v).trim().toLowerCase())

export const deporteDelTorneo = (torneo) =>
  normaliza(torneo?.temporadas?.deporte_id || torneo?.temporada?.deporte_id || torneo?.deporte) || null

export const gruposParaTorneoInterno = (grupos = [], deporteTorneo = null) => {
  const lista = (grupos || []).filter(Boolean)
  const deporte = normaliza(deporteTorneo)
  if (!deporte) return lista
  return lista.filter((g) => normaliza(g.deporte) === deporte)
}
